import { combineReducers, Reducer } from 'redux'

// core
import config, { configActions } from './core/config.store'
import route, { routeActions } from './core/route.store'
import auth, { authActions } from './core/auth.store'
import user, { userActions } from './core/user.store'
import i18n, { i18nActions } from './core/i18n.store'
import main, { mainActions } from './core/main.store'
import grid, { gridActions } from './core/grid.store'
import department, { departmentActions } from './core/department.store'

// admin
import admin, { adminActions } from './admin/admin.store'
import adminUsers, { adminUsersActions } from './admin/adminUsers.store'
import accessControl, { accessControlActions } from './admin/accessControl.store'
import logDashboard, { logDashboardActions } from './admin/logDashboard.store'

// main
import product, { productActions } from './main/product.store'
import season, { seasonActions } from './main/season.store'
import order, { orderActions } from './main/order.store'
import coupon, { couponActions } from './main/coupon.store'
import customer, { customerActions } from './main/customer.store'
import inquiryMgmt, { inquiryMgmtActions } from './main/inquiryMgmt.store'
import box, { boxActions } from './main/box.store'
import shipment, { shipmentActions } from './main/shipment.store'
import dealerPrice, { dealerPriceActions } from './main/dealerPrice.store'
import settlement, { settlementActions } from './main/settlement.store'

// home
import customerAuth, { customerAuthActions } from './home/customerAuth.store'
import customerOrder, { customerOrderActions } from './home/customerOrder.store'
import wholesale, { wholesaleActions } from './home/wholesale.store'
import shop, { shopActions } from './home/shop.store'
import payment, { paymentActions } from './home/payment.store'
import inquiry, { inquiryActions } from './home/inquiry.store'

const appReducer: Reducer = combineReducers({
	// core
	config,
	route,
	auth,
	user,
	i18n,
	main,
	grid,
	department,

	// admin
	admin,
	adminUsers,
	accessControl,
	logDashboard,

	// main
	product,
	season,
	order,
	coupon,
	customer,
	inquiryMgmt,
	box,
	shipment,
	dealerPrice,
	settlement,

	// home
	customerAuth,
	customerOrder,
	wholesale,
	shop,
	payment,
	inquiry,
})

export default appReducer

export {
	// core
	configActions,
	routeActions,
	authActions,
	userActions,
	i18nActions,
	mainActions,
	gridActions,
	departmentActions,

	// admin
	adminActions,
	accessControlActions,
	adminUsersActions,
	logDashboardActions,

	// main
	productActions,
	seasonActions,
	orderActions,
	couponActions,
	customerActions,
	inquiryMgmtActions,
	boxActions,
	shipmentActions,
	dealerPriceActions,
	settlementActions,

	// home
	customerAuthActions,
	customerOrderActions,
	wholesaleActions,
	shopActions,
	paymentActions,
	inquiryActions,
}
